import React from "react";
import ProfileMenu from "../../../components/CommonForBoth/TopbarDropdown/ProfileMenu";

// Importa estilos do NeoHeader principal para estilizar o ProfileMenu e sub-componentes
import "../../../components/VerticalLayout/NeoHeader.css";

/**
 * PlatformHeader — Header do Painel Administrativo Global.
 * Visual alinhado ao NeoHeader principal (contendo o menu de perfil interativo), na cor branca.
 */
const PlatformHeader = () => {
    return (
        <div className="platform-header">
            <div className="platform-header-left">
                <h1 className="platform-header-title">Painel Gerencial</h1>
            </div>
            
            <div className="platform-header-right">
                <span className="platform-admin-badge me-3">
                    <i className="ph-light ph-shield-star me-1" />
                    Super Admin
                </span>
                <ProfileMenu />
            </div>
        </div>
    );
};

export default PlatformHeader;
